import { colors } from "../../../../data/colors";
import { stdObject } from "../../../../data/types/stdObject";
import convertDate from "../../../../utils/convertDate";
import { toFixedDecimal } from "../../../../utils/toFixedDecimal";
import { toPrice } from "../../../../utils/toPrice";

export const writeMovementsProfit = ({
  t,
  id,
  searchValues,
  responseReportData,
  vPayments,
  cPayments,
}: stdObject) => {
  let docTotal = 0;
  let costTotal = 0;
  let resTotal = 0;
  let commTotal = 0;
  let chargeTotal = 0;
  let profitTotal = 0;

  const docName = (e: stdObject, suf: string) =>
    t(
      `c.${e[`DOC${suf}`] === "SAL" ? "SALP" : e[`DOC${suf}`] === "PRE" ? "PREP" : e[`DOC${suf}`]}`,
    ) + ` ${e[`SER${suf}`]}-${e[`COD${suf}`]}`;

  let results: stdObject[] = responseReportData.mov.map((e: stdObject) => {
    e.NDOCREN = docName(e, "REN");

    if (!e.ISOUT) {
      e.PREREN = -e.PREREN;
      e.TOTREN = -e.TOTREN;
    }
    if (e.ISOUT || e.DOCREN === "REG") {
      e.COMREN = responseReportData.comm
        .filter(
          (v: stdObject) =>
            v.DOCCOY === e.DOCREN &&
            v.SERCOY === e.SERREN &&
            v.CODCOY === e.CODREN &&
            v.LINCOY === e.LINREN,
        )
        .reduce(
          (acc: number, curr: stdObject) =>
            (acc += ((curr.PROCOY * curr.PRECOY) / 100) * curr.CANCOY),
          0,
        );
      commTotal += e.COMREN;
      e.TPCOREN = e.PCOREN !== 0 ? toPrice(e.CANREN * e.PCOREN) : "";

      if (e.DOCREN === "REG") {
        e.COMREN = -e.COMREN;
        e.TPCOREN = -e.TPCOREN;
      }
      const priceRes =
        e.DOCREN === "REG"
          ? (e.PREREN + e.PCOREN) * e.CANREN
          : (e.PREREN - e.PCOREN) * e.CANREN;
      const profit = priceRes - e.COMREN;
      const porcent =
        e.PREREN !== 0 ? (profit * 100) / (e.PREREN * e.CANREN) : 0;
      resTotal += priceRes;
      e.RESREN = toPrice(priceRes);
      profitTotal += profit;
      costTotal += e.CANREN * e.PCOREN;
      e.TRESREN = profit;
      e.PORREN = toFixedDecimal(porcent, 2) + "%";
      e.COMREN = e.COMREN !== 0 ? toPrice(e.COMREN) : "";
    }
    e.PCOREN = e.PCOREN !== 0 ? toPrice(e.PCOREN) : "";
    docTotal += e.TOTREN;
    e.TOTREN = toPrice(e.TOTREN);
    e.PREREN = toPrice(e.PREREN);
    return e;
  });

  responseReportData.money.forEach((e: stdObject, index: number) => {
    profitTotal -= e.CA2DIN;
    chargeTotal += e.CA2DIN;
    const payList = e.AREA === "c" ? cPayments : vPayments;
    const method = payList.find(
      (v: stdObject) => v.CODTPA === e.TIPDIN,
    )?.NOMTPA;
    results.push({
      FECREN: e.FECDIN,
      NDOCREN: docName(e, "DIN"),
      NOMREN: `${t("p.payment")} (${method})`,
      PREREN: toPrice(e.CANDIN),
      CHAREN: toPrice(e.CA2DIN),
      PORREN: e.CARDIN + "%",
      TRESREN: toPrice(-e.CA2DIN),
      BGCOLOR: index % 2 ? colors.pink : colors.pink2,
    });
  });
  results = results
    .sort((a, b) => (b.FECREN < a.FECREN ? 1 : b.FECREN > a.FECREN ? -1 : 0))
    .map((e: stdObject, index: number) => {
      if (e.TRESREN < 0) {
        e.BGCOLOR = index % 2 ? colors.pink : colors.pink2;
      }
      e.FECREN = convertDate({ info: e.FECREN, t });
      e.TRESREN = toPrice(e.TRESREN);
      return e;
    });
  return {
    ...searchValues,
    [id]: {
      ...searchValues[id],
      results,
      TOTREN: toPrice(docTotal),
      RESREN: toPrice(resTotal),
      TRESREN: toPrice(profitTotal),
      COMREN: toPrice(commTotal),
      CHAREN: toPrice(chargeTotal),
      TPCOREN: toPrice(costTotal),
    },
  };
};
